//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.ElementIntBuilder.js";
let d=[[[0,"EnumValue",1,0]],[],[]];
SPLM.CAM.PatternSequencing = class extends SPLM.CAM.ElementIntBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.PatternSequencing";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.PatternSequencing.Types = Object.freeze({
    "Undefined" : "Undefined", "SteepLast" : "SteepLast", "OutsideIn" : "OutsideIn", "InsideOut" : "InsideOut", "SteepFirst" : "SteepFirst", "OutsideInAlternate" : "OutsideInAlternate", "InsideOutAlternate" : "InsideOutAlternate", "StartLeft" : "StartLeft", "StartRight" : "StartRight", "Standard" : "Standard", "TowardToGuide" : "TowardToGuide", "AwayFromGuide" : "AwayFromGuide", "TowardFirstCurve" : "TowardFirstCurve", "AlternateFromGuide1" : "AlternateFromGuide1", "AlternateTowardGuide1" : "AlternateTowardGuide1"});

export default SPLM;